import React from "react";
import Dashboard from "./Dashboard";
import NavBar from "./NavBar";

const DashboardPage = (props) => {
  return (
    <div>
      <NavBar />
      <Dashboard />
    </div>
  );
};

export default DashboardPage;
